import axios from 'api/axios'
import { ClientProfile, VendorType } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface for the Body of updateVendorDetails
 */
export interface VendorDetailsBody {
	appName: string
	apiKey: string
	sourceWaNumber: string
	wabaId: string
	vendorSelected: VendorType
	userId: string
	password: string
	two_way_userId: string
	two_way_password: string
	wa_token: string
	wa_phone_id: string
	ts_apiKey: string
	airtelCustomerId: string
	airtelUsername: string
	airtelPassword: string
	ts_channelId: string
	pinnacleApiKey: string
}

/**
 * API call for Update Vendor Details of client
 * @param id - id of client to be send to backend for Update Vendor Details of client
 * @returns AdminResponse - Response object returned from the server
 */

export const updateVendorDetails = async (
	id: string,
	body: VendorDetailsBody
) => {
	try {
		const { data } = await axios.put<ClientProfile>(
			`client/update-vendor-details/${id}`,
			body
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default updateVendorDetails
